import React from "react";
import "./PlayerOfferNeonPanel.css";

export default function PlayerOfferNeonPanel({
    offer,
    onAccept,
    onReject,
    toAbsoluteUrl,
    children,
    header, // ✅ optional header slot (Offer From + Policy) to match original order
}) {
    if (!offer) {
        return (
            <div className="player-neon-wrapper">
                <div className="player-neon-device loading">
                    <div className="player-neon-screen">
                        <h2 className="player-neon-title">LOADING OFFER...</h2>
                    </div>
                </div>
            </div>
        );
    }

    const {
        scoutName,
        clubName,
        agentName,
        contractDuration,
        additionalNotes,
        uploadedContractUrl,
        contractPolicyUrl,
        statusText,
        submittedAt,
        badge,
    } = offer;

    // ✅ Only glow for positive/active states (prevents "yellow on yellow" for Status row)
    const shouldGlowStatus =
        typeof statusText === "string" &&
        ["active", "admin approved"].includes(statusText.trim().toLowerCase());

    return (
        <div className="player-neon-wrapper">
            <div className="player-neon-device">
                {/* corner lights */}
                <span className="player-corner tl" />
                <span className="player-corner tr" />
                <span className="player-corner bl" />
                <span className="player-corner br" />

                <div className="player-neon-screen">
                    {/* Title */}
                    <div className="player-title-row">
                        <div className="player-line" />
                        <h2 className="player-neon-title">CONTRACT OFFER</h2>
                        <div className="player-line" />
                    </div>

                    {/* ✅ Header area (renders BEFORE main offer details) */}
                    {header ? <div className="player-neon-header">{header}</div> : null}

                    {/* Main offer details */}
                    <div className="player-neon-content">
                        {scoutName ? <Row label="Scout Name" value={scoutName} /> : null}
                        {clubName ? <Row label="Club Name" value={clubName} /> : null}
                        {agentName ? <Row label="Agent Name" value={agentName} /> : null}

                        {/* keep duration even if empty */}
                        <Row label="Contract Duration" value={contractDuration} />

                        {additionalNotes ? (
                            <Row label="Additional Notes" value={additionalNotes} />
                        ) : null}

                        {uploadedContractUrl ? (
                            <Row
                                label="View Uploaded Contract"
                                value={
                                    <a
                                        href={toAbsoluteUrl(uploadedContractUrl)}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="player-link"
                                    >
                                        View Contract
                                    </a>
                                }
                            />
                        ) : null}

                        {contractPolicyUrl ? (
                            <Row
                                label="Contract Policy"
                                value={
                                    <a href={contractPolicyUrl} download className="player-link">
                                        Read Official Policy
                                    </a>
                                }
                            />
                        ) : null}

                        {submittedAt ? (
                            <Row
                                label="Submitted At"
                                value={new Date(submittedAt).toLocaleString()}
                            />
                        ) : null}

                        {/* ✅ Fix: don't glow Status by default (prevents yellow label + yellow value) */}
                        {statusText ? (
                            <Row label="Status" value={statusText} glow={shouldGlowStatus} />
                        ) : null}
                    </div>

                    {/* Extras area (textarea / checkbox / buttons etc.) */}
                    {children ? <div className="player-neon-extras">{children}</div> : null}

                    {/* Action buttons (only if still pending) */}
                    {statusText === "Pending player response" ? (
                        <div className="player-action-buttons">
                            <button className="player-accept-btn" onClick={onAccept}>
                                Accept Offer
                            </button>
                            <button className="player-reject-btn" onClick={onReject}>
                                Reject Offer
                            </button>
                        </div>
                    ) : null}

                    {/* Badge */}
                    {badge ? (
                        <div className="player-status-badge">
                            <small>{badge.subtitle}</small>
                            <strong>{badge.title}</strong>
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
}

function Row({ label, value, glow }) {
    return (
        <div className="player-row">
            <span className="player-label">{label}:</span>
            <span className={glow ? "player-value glow" : "player-value"}>{value}</span>
        </div>
    );
}